import { get } from 'lodash';
import { getLocationsCarouselState } from '../LocationCardCarousel/selectors';

export const mapStateToProps = (state, ownProps) => {
    const carouselState = getLocationsCarouselState(state);

    const locationId = get(carouselState, 'locationId', ownProps.locationId);

    return {
        locationId,
    };
};
